import * as React from 'react'
import { ActivitiesContextProvider } from '../context'
import { ActivitySummaryContextProvider } from './context'
import { ActivitySummaryButton, ActivitySummaryDialog } from './components'

export type Props = {
  onBatchContentFetched: (count: number) => void
  expanded: boolean
}

export function ActivitySummary(props: Props) {
  return (
    <ActivitiesContextProvider>
      <ActivitySummaryContextProvider>
        <ActivitySummaryButton
          onBatchContentFetched={props.onBatchContentFetched}
          expanded={props.expanded}
        />
        <ActivitySummaryDialog />
      </ActivitySummaryContextProvider>
    </ActivitiesContextProvider>
  )
}
